/* eslint-disable no-unused-vars */
import React from 'react';
import {
  Grid,
  Tabs,
  Divider,
  Select,
  Button,
  Option,
  Flexbox,
} from '@sede-enterprise/shell-ds-react-framework';
import { ArrowCw } from '@sede-enterprise/shell-ds-react-framework/build/esm/components/Icon/components';
import { SubTitle } from '../ScenerioModelling.styles';
import { useAppSelector } from '../../../redux/hooks';
import { formatRegionName, getRegionVal } from '../../../utils';
import { BUSINESS_PLAN_KEY, TABITEMS } from '../../../constants';
import { RegionTabsProps } from '../../../Types/types';

const RegionTabs: React.FC<RegionTabsProps> = ({
  selectedRegion,
  handleTabChange,
  subRegionOptions,
  selectedSubRegion,
  setSelectedSubRegion,
  handleRevertAllToOriginal,
}) => {
  const { userRegionFlags, tabKey, loggedInUserRegion } = useAppSelector(
    (state) => state.dashboard,
  );
  const { scenarioModellingTabTitle } = useAppSelector((state) => state.scenarioModelling);

  const activeRegion = formatRegionName(getRegionVal(userRegionFlags, loggedInUserRegion));
  return (
    <Grid flow='row'>
      <SubTitle>{scenarioModellingTabTitle}</SubTitle>
      <Grid gap='0' style={{ gridAutoRows: 'auto' }}>
        {activeRegion ? (
          <Tabs
            data-testid='tab-change'
            items={[{ key: activeRegion, label: activeRegion }]}
            activeKey={activeRegion}
            defaultActiveKey={activeRegion}
            onChange={handleTabChange}
          />
        ) : (
          <Tabs
            data-testid='tab-change'
            items={TABITEMS}
            activeKey={selectedRegion}
            defaultActiveKey={selectedRegion}
            onChange={handleTabChange}
          />
        )}
        <Divider size='medium' direction='horizontal' color='#F5F5F5' />
      </Grid>
      <Flexbox style={{ paddingBottom: '10px' }}>
        {tabKey !== BUSINESS_PLAN_KEY ? (
          <Select
            size='medium'
            data-test-id='sub-region-select'
            allowClear={false}
            value={selectedSubRegion}
            style={{ width: '150px', zIndex: 10 }}
            onChange={(value) => setSelectedSubRegion(value)}
          >
            {subRegionOptions?.map((option) => (
              <Option key={option.id} value={option.value}>
                {option.value}
              </Option>
            ))}
          </Select>
        ) : null}

        <Button
          variant='outlined'
          size='medium'
          icon={<ArrowCw />}
          style={{ marginLeft: '10px' }}
          onClick={() => handleRevertAllToOriginal()}
        >
          Reset
        </Button>
      </Flexbox>
    </Grid>
  );
};
export default RegionTabs;
